var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"players"},_vm._l((_vm.players),function(ref,index){
var teamID = ref.teamID;
var type = ref.type;
var name = ref.name;
return _c('li',{class:{ 'active' : _vm.activeSeatID === index }},[_c('span',[_vm._v(_vm._s(teamID.toUpperCase())+" "+_vm._s(_vm.getTypeIndicator(type)))]),_vm._v("\n        "+_vm._s(name)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }